var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_9162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_602_9162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_602_9162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.56 3C13.2532 3 14.9084 3.50209 16.3163 4.44279C17.7241 5.38348 18.8214 6.72053 19.4694 8.28485C20.1173 9.84917 20.2869 11.5705 19.9565 13.2312C19.6262 14.8918 18.8108 16.4173 17.6136 17.6145C16.4163 18.8118 14.8909 19.6272 13.2302 19.9575C11.5695 20.2878 9.84819 20.1183 8.28387 19.4703C6.71955 18.8224 5.38251 17.7251 4.44181 16.3172C3.50112 14.9094 2.99902 13.2542 2.99902 11.561C2.99902 9.29048 3.90098 7.11296 5.50648 5.50746C7.11198 3.90196 9.28951 3 11.56 3Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.185 18.7744C20.4642 18.7744 20.737 18.8572 20.9691 19.0123C21.2011 19.1674 21.382 19.3878 21.4887 19.6457C21.5955 19.9036 21.6234 20.1873 21.5689 20.4611C21.5143 20.7348 21.3799 20.9862 21.1824 21.1835C20.985 21.3808 20.7335 21.5151 20.4597 21.5694C20.1859 21.6238 19.9022 21.5957 19.6444 21.4887C19.3866 21.3818 19.1663 21.2008 19.0114 20.9686C18.8564 20.7364 18.7739 20.4635 18.774 20.1844C18.7743 19.8104 18.9231 19.4517 19.1877 19.1873C19.4523 18.9229 19.811 18.7744 20.185 18.7744Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_9162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.362a7d27420a4e47c6d60567545adf3a.svg";
export { ForwardRef as ReactComponent };